import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaSelectOptionList } from "./VaSelectOptionList-e860307d.mjs";
const VaSelectOptionList = withConfigTransport(_VaSelectOptionList);
export {
  VaSelectOptionList as V
};
//# sourceMappingURL=index-dd2959a3.mjs.map
